import { useContext, useSyncExternalStore } from 'react';
import type { Session, SessionState } from '../net/session';
import { SessionContext } from './context';

export function useSession(): Session {
  const session = useContext(SessionContext);
  if (!session) throw new Error('useSession needs a SessionProvider above it.');
  return session;
}

export function useSessionState(): SessionState {
  const session = useSession();
  return useSyncExternalStore(session.subscribe, session.getState);
}
